export default __webpack_public_path__ + "static/landingweb-872cc8a8d51629fba627f52bffc01ff5.png";